var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionsBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "questions",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3.5 0.22 1445.5 532.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5V83l74.844-30.33a304.92 304.92 0 0 1 197.054-10.942 304.9 304.9 0 0 0 145.391 4.832l172.987-36.443A460.66 460.66 0 0 1 825.551 22.11 460.7 460.7 0 0 0 965.863 44H1114.6c31.23 0 62.41-2.29 93.29-6.852l82.18-12.138A310.8 310.8 0 0 1 1442 40.5v335.136c0 62.898-46.55 116.084-108.9 124.413a125.5 125.5 0 0 1-29.26.467l-344.424-34.862a555 555 0 0 0-101.916-.908c32.577 1.143 36.384 47.995 4.419 54.383l-64.716 12.932a39.57 39.57 0 0 1-23.605-2.547l-67.038-29.318a241.94 241.94 0 0 0-165.866-10.245l-22.27 6.619a305.45 305.45 0 0 1-176.614-.774l-11.718-3.594a346 346 0 0 0-127.872-14.211l-43.288 3.309a647.6 647.6 0 0 0-108.364 17.62L-3.5 512.5l3.5-289z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1344,
    y1: 170.5,
    x2: -326.5,
    y2: 453.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#366BC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#415985"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsBackground);
export default __webpack_public_path__ + "static/media/questions_background.df5f2084a4a821815922b919c4ce3df1.svg";
export { ForwardRef as ReactComponent };